import { ErrorHandler, Injectable } from '@angular/core';
import { ConfiguracoesProjeto } from '..';
import { HttpClient } from '@angular/common/http';

export class CustomError extends ErrorHandler {
  toString() {
    return 'Erro ao ler parâmetros de configuração';
  }
}

@Injectable()
export class ParametrosService {
  public static readonly CIDADAO = 1;
  public static readonly EMPRESA = 2;
  public static readonly INSTIUICAO = 3;

  public urlBase: string;

  public configuracao: ConfiguracoesProjeto = null;

  public contextoConsumidor: number = ParametrosService.CIDADAO;

  constructor(private http: HttpClient) {
    this.getJSON()
    .then((data: any) => {
      this.configuracao = data;
    })
 }

  async setConfiguracao(config) {
    this.configuracao = config
  }

  public getConfiguracao() {
    return this.configuracao;
  }


  getJSON() {
    let result = new Promise((res,rej)=>{
      this.http.get<ConfiguracoesProjeto>('assets/nbpp.json')
        .toPromise()
        .then(data => {
          res(data);
        })
    })
    return result;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/service/parametros.service.ts